

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_FALL_BILD = '[VeranstaltungenModul] GetFunkprotokollFallBild laden';
export const GET_FUNKPROTOKOLL_FALL_BILD_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollFallBild ausführen';
export const GET_FUNKPROTOKOLL_FALL_BILD_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollFallBild laden erfolgreich';
export const GET_FUNKPROTOKOLL_FALL_BILD_FEHLER = '[VeranstaltungenModul] GetFunkprotokollFallBild Ladefehler';
export const GET_FUNKPROTOKOLL_FALL_BILD_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollFallBild nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollFallBildAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD;
        constructor( public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_AUSFUEHREN;
        constructor( public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_ERFOLGREICH;
        constructor(public payload: string,  public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string ,  public fall_id:string ,  public bild_id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollFallBildNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_FALL_BILD_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollFallBildActions =
    GetFunkprotokollFallBildAction
    | GetFunkprotokollFallBildAusfuehrenAction
    | GetFunkprotokollFallBildErfolgreichAction
    | GetFunkprotokollFallBildFehlerAction
    | GetFunkprotokollFallBildNichtAusgefuehrtAction
    ;
